import { Box, Button, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'

import { useAdmissionExamStore } from '../../store/admission-exam.store'
import LanguageSelector from './LanguageSelector'
import { useTranslation } from 'react-i18next'
import { Icons } from '../../utils/utilities'


const examWindowHeaderStyle = {
    padding: "20px",
    background: "#151D48",
    color: "white",
    zIndex: 1000,
    '@media(max-width:900px)': {
        flexDirection: "column",
        height: "fit-content"
    }
}


const CountDown = observer( ( { finishExam } ) => {
    const ExamStore = useAdmissionExamStore()
    const { endsAt, examDuration } = ExamStore.getAttemptDetails

    const { t } = useTranslation()

    // Helper to calculate seconds remaining using dayjs
    const getSecondsLeft = () => {
        const now = dayjs()
        const end = dayjs( endsAt )
        const diff = end.diff( now, 'second' )
        return Math.max( 0, diff )
    }

    const [remainingTime, setRemainingTime] = useState( getSecondsLeft() )

    // Clean formatting using Dayjs Duration
    const formatTime = ( totalSeconds ) => {
        return dayjs.duration( totalSeconds, 'seconds' ).format( 'HH:mm:ss' )
    }

    useEffect( () => {
        const interval = setInterval( () => {
            const timeLeft = getSecondsLeft()
            setRemainingTime( timeLeft )

            // Sync with MobX store
            ExamStore.currentRemainingTime = timeLeft

            if ( timeLeft <= 0 ) {
                clearInterval( interval )
                finishExam( "TimeUP", 0, 0 )
            }
        }, 1000 )

        return () => clearInterval( interval )
    }, [endsAt, finishExam, ExamStore] )

    // Derived values
    const timeElapsed = Math.max( 0, examDuration - remainingTime )

    return (
        <Box display="flex" borderRadius="20px" padding="5px 10px" border={`1px solid ${remainingTime < 300 ? "red" : "white"}`} alignItems="center" gap="10px">
            {Icons.default.Clock}
            <Typography
                variant="subtitle2"
                sx={{ color: remainingTime < 300 ? "red" : "white" }}
            >
                {formatTime( remainingTime )}
            </Typography>
        </Box>
    )
} )



const ExamAttemptHeader = observer( ( { handleClickOnFinishExam, finishExam, totalPoints, totalSubmissions, totalQuestions } ) => {

    const { t } = useTranslation()

    const examAttemptHeaderRef = useRef()

    const ExamStore = useAdmissionExamStore()

    const exam = ExamStore.getExam.exam


    return (
        <Box ref={examAttemptHeaderRef} sx={examWindowHeaderStyle}>


            <Box display="flex" alignItems="center" marginBottom="10px" justifyContent="space-between">
                <Box textAlign="right" display="flex" gap="5px" flexDirection="column" alignItems="flex-start">
                    <Typography variant='h6' display={{ sm: "flex", xs: "none" }} alignItems="center" noWrap> {exam && exam.exam_name}</Typography>
                    <Typography gutterBottom variant='subtitle2' fontSize="12px">{t( "label.totalMarks" )}: {totalPoints}</Typography>
                    <LanguageSelector variant="filled" />
                </Box>
                <Box display="flex" alignItems="center" gap="20px" justifyContent={{ lg: "initial", md: "initial", sm: "space-between", xs: "space-between" }}>
                    <Box textAlign="right" display="flex" gap="10px" flexDirection="column" alignItems="flex-end">
                        <Typography variant='subtitle2' fontSize="14px">{totalSubmissions} / {totalQuestions} {t( "label.answered" )}</Typography>
                        <Tooltip title="Answer all the questions" ><span><Button variant='contained' color='errorMessage' size="small" disableElevation onClick={handleClickOnFinishExam} sx={{ '&.Mui-disabled': { background: "grey" }, textTransform: "capitalize !important", width: "fit-content", '@media(max-width:350px)': { width: "100% !important" } }}>{t( "button.submitAndFinish" )}</Button></span></Tooltip>
                        <CountDown finishExam={finishExam} />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
} )

export default ExamAttemptHeader
